
<template>
  <div class="right_item">
    <div class="title1">{{title}}</div>
    <div class="right_item_info">
      <div class="right_item_item"><slot name="left"></slot></div>
      <div class="right_item_item right_item_item1">
        <div class="videoBox"><slot name="right"></slot></div>
        <h5>{{title1}}</h5>
      </div>
    </div>
  </div>
</template>
<script setup >
// props="['width','height','right1Data']"
import { ref, onMounted,defineProps,watchEffect } from "vue";
import * as echarts from "echarts";
const props =defineProps({
  title: {
    type: String,
    default: () => "",
  },
  title1: {
    type: String,
    default: () => "",
  },
})
// console.log(props.leftData2);
const myEcharts = ref(null);

onMounted(() => {


});



</script>
<style lang="less">
.title1{
  width: 100%;
  height: 40px;
  font-size: 30px;
  background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/hongshuhuang/mj.png") no-repeat left bottom;
  color: #E0EFFF;
  text-align: left;
}
.right_item{
  width: 48%;
  height: 45%;
  display: flex;
  flex-direction: column;
  .right_item_info{
    width: 100%;
    flex: 1;
    display: flex;
    .right_item_item{
      width: 50%;
      height: 100%;
    }
    .right_item_item1{
      display: flex;
      flex-direction: column;
      padding: 70px 0 0 50px;
      .videoBox{
        width: 100%;
        flex: 1;
        background: #fff;
      }
      h5{
        height: 85px;
        line-height: 85px;
        background: #074870;
        color: #fff;
        font-size: 30px;
      }
      }
    }
}
</style>
